module.exports = __webpack_public_path__ + "media/images/1200/sleep_paralysis_night_mare-2e57edd313e6754cdf972734e168ae37.webp";